import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { addAnnouncementApi, addChecklistDataAPI, addFailureReasonApi, addOutofServiceApi, deleteAnnouncementsApi, deleteCheckListApi, deleteFailureReasonApi, deleteOutofServiceApi, editAnnouncementApi, editBufferRulesAPI, editFailureReasonApi, editOutofServiceApi, editTimeSimulationHit, fetchBufferRulesAPI, fetchDriverScoreApiHit, fetchLocationRegionApiAHit, fetchTerminalQuanitityApiHit, getAnnouncementDetailsApi, getAnnouncementsApi, getChecklistApi, getChecklistDataDetailsApi, getCheckoutlistApi, getFailureReasonApi, getFailureReasonDetailsApi, getKmlDataApiHit, getOutofServiceApi, getOutofServiceDetailsApi, getRoutingConfigDetailsApi, getScheduleCroneApiHit, getTransportAPI, orderApiSubmitHit, placeOrderApiHit, updateCheckListStatusAPI, updateCheckOutListStatusAPI, updateDriverStatusApiHit, updateDriverTasksApiHit, updateOrderStatusApiHit, updateRoutingConfigDetailsApi, updateTransportStatusAPI } from '../../apis/hyperdrive/setting';

const initialState = {
  transport: [],
  loading: false,
  error: null,
  flavors: [],
  getTransportation: {}
};

export const getTransportation = createAsyncThunk(
  'common/getTransportation',
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getTransportAPI(filters);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const updateTransportStatus = createAsyncThunk(
  'common/updateTransportStatus',
  async ({ data, transportId }, { rejectWithValue }) => {
    try {
      const res = await updateTransportStatusAPI(data, transportId);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getChecklist = createAsyncThunk(
  'common/getChecklist',
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getChecklistApi(filters);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getCheckoutlist = createAsyncThunk(
  'common/getCheckoutlist',
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getCheckoutlistApi(filters);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);


export const updateCheckListStatus = createAsyncThunk(
  'common/updateCheckListStatus',
  async ({ data, checklistId }, { rejectWithValue }) => {
    try {
      const res = await updateCheckListStatusAPI(data, checklistId);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteCheckList = createAsyncThunk(
  'common/deleteCheckList',
  async (deleteCheckList, { rejectWithValue }) => {
    try {
      const res = await deleteCheckListApi(deleteCheckList);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)

export const getChecklistDataDetails = createAsyncThunk(
  'common/getChecklistDataDetails',
  async (reasonId, { rejectWithValue }) => {
    try {
      const res = await getChecklistDataDetailsApi(reasonId)
      return res;
    }
    catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const addChecklistData = createAsyncThunk(
  'common/addChecklistData',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await addChecklistDataAPI(data);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)
// checklist

export const updateCheckOutListStatus = createAsyncThunk(
  'common/updateCheckOutListStatus',
  async ({ data, checklistId }, { rejectWithValue }) => {
    try {
      const res = await updateCheckOutListStatusAPI(data, checklistId);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const getFailureReason = createAsyncThunk(
  'common/getFailureReason',
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getFailureReasonApi(filters);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getFailureReasonDetails = createAsyncThunk(
  'common/getFailureReasonDetails',
  async (reasonId, { rejectWithValue }) => {
    try {
      const res = await getFailureReasonDetailsApi(reasonId)
      return res;
    }
    catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const addFailureReason = createAsyncThunk(
  'common/addFailureReason',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await addFailureReasonApi(data);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)
export const editFailureReason = createAsyncThunk(
  'common/editFailureReason',
  async ({ data, reasonId }, { rejectWithValue }) => {
    try {
      const res = await editFailureReasonApi(data, reasonId);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)

export const deleteFailureReason = createAsyncThunk(
  'common/deleteFailureReason',
  async (deleteFailureReason, { rejectWithValue }) => {
    try {
      const res = await deleteFailureReasonApi(deleteFailureReason);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)

export const getAnnouncements = createAsyncThunk(
  'common/getAnnouncements',
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getAnnouncementsApi(filters);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getAnnouncementDetails = createAsyncThunk(
  'common/getAnnouncementDetails',
  async (reasonId, { rejectWithValue }) => {
    try {
      const res = await getAnnouncementDetailsApi(reasonId)
      return res;
    }
    catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const addAnnouncement = createAsyncThunk(
  'common/addAnnouncement',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await addAnnouncementApi(data);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)

export const editAnnouncement = createAsyncThunk(
  'common/editAnnouncement',
  async ({ data, announcementId }, { rejectWithValue }) => {
    try {
      const res = await editAnnouncementApi(data, announcementId);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)

export const deleteAnnouncements = createAsyncThunk(
  'common/deleteAnnouncements',
  async (deleteAnnouncements, { rejectWithValue }) => {
    try {
      const res = await deleteAnnouncementsApi(deleteAnnouncements);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)

//  out of service APIs

export const getOutofService = createAsyncThunk(
  'common/getOutofService',
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getOutofServiceApi(filters);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const deleteOutofService = createAsyncThunk(
  'common/deleteOutofService',
  async (deleteOutofService, { rejectWithValue }) => {
    try {
      const res = await deleteOutofServiceApi(deleteOutofService);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)

export const getOutofServiceDetails = createAsyncThunk(
  'common/getOutofServiceDetails',
  async (reasonId, { rejectWithValue }) => {
    try {
      const res = await getOutofServiceDetailsApi(reasonId)
      return res;
    }
    catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const addOutofService = createAsyncThunk(
  'common/addOutofService',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await addOutofServiceApi(data);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)

export const editOutofService = createAsyncThunk(
  'common/editOutofService',
  async ({ data, reasonId }, { rejectWithValue }) => {
    try {
      const res = await editOutofServiceApi(data, reasonId);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)



export const fetchBufferRules = createAsyncThunk(
  'common/fetchBufferRules',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchBufferRulesAPI();
      return res?.data
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)

export const editBufferRules = createAsyncThunk(
  'common/editBufferRules',
  async (data, { rejectWithValue }) => {
    try {
      const res = await editBufferRulesAPI(data);
      return res?.data
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)

export const getRoutingConfigDetails = createAsyncThunk(
  'common/getRoutingConfigDetails',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getRoutingConfigDetailsApi(data);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
) 

export const updateRoutingConfigDetails = createAsyncThunk(
  'common/updateRoutingConfigDetails',
  async (data, { rejectWithValue }) => {
    try {
      const res = await updateRoutingConfigDetailsApi(data);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
) 

export const updateOrderStatusApi = createAsyncThunk(
  'common/updateOrderStatusApi',
  async (data, { rejectWithValue }) => {
    try {
      const res = await updateOrderStatusApiHit(data);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
) 
export const updateDriverStatusApi = createAsyncThunk(
  'common/updateDriverStatusApi',
  async (data, { rejectWithValue }) => {
    try {
      const res = await updateDriverStatusApiHit(data);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
) 

export const updateDriverTasksApi = createAsyncThunk(
  'common/updateDriverTasksApi',
  async (data, { rejectWithValue }) => {
    try {
      const res = await updateDriverTasksApiHit(data);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
) 

export const fetchDriverScoreApi = createAsyncThunk(
  'common/fetchDriverScoreApi',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchDriverScoreApiHit(data);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
) 

export const placeOrderApi = createAsyncThunk(
  'common/placeOrderApi',
  async (data, { rejectWithValue }) => {
    try {
      const res = await placeOrderApiHit(data);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
) 

export const orderApiSubmit = createAsyncThunk(
  'common/orderApiSubmit',
  async (data, { rejectWithValue }) => {
    try {
      const res = await orderApiSubmitHit(data);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
) 

export const fetchLocationRegionApi = createAsyncThunk(
  'common/fetchLocationRegionApi',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchLocationRegionApiAHit(data);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
) 

export const fetchTerminalQuanitityApi = createAsyncThunk(
  'common/fetchTerminalQuanitityApi',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchTerminalQuanitityApiHit(data);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
) 

export const editTimeSimulation = createAsyncThunk(
  'common/editTimeSimulation',
  async (data, { rejectWithValue }) => {
    try {
      const res = await editTimeSimulationHit(data);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
) 

export const getScheduleCroneApi = createAsyncThunk(
  'common/getScheduleCroneApi',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getScheduleCroneApiHit(data);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
) 

export const getKmlData = createAsyncThunk(
  'common/getKmlData',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getKmlDataApiHit(data);
      return res
    }
    catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
) 

const commonDriveSlice = createSlice({
  name: 'commonHyperDrive',
  initialState,
  reducers: {
    setCommonHyperdrive: (state, action) => {
      return { ...state, singleDrive: action.payload }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTransportation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTransportation.fulfilled, (state, action) => {
        state.loading = false;
        state.mainTransportData = action.payload;
      })
      .addCase(getTransportation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      .addCase(updateTransportStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTransportStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.transportUpdateData = action.payload;
      })
      .addCase(updateTransportStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      .addCase(getChecklist.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getChecklist.fulfilled, (state, action) => {
        state.loading = false;
        state.mainChecklistData = action.payload;
      })
      .addCase(getChecklist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      .addCase(updateCheckListStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCheckListStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.transportUpdateData = action.payload;
      })
      .addCase(updateCheckListStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      .addCase(getFailureReason.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFailureReason.fulfilled, (state, action) => {
        state.loading = false;
        state.mainFailureReasonData = action.payload;
      })
      .addCase(getFailureReason.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      .addCase(addFailureReason.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addFailureReason.fulfilled, (state, action) => {
        state.loading = false;
        state.addMainFailureReasonData = action.payload;
      })
      .addCase(addFailureReason.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      .addCase(getFailureReasonDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFailureReasonDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.mainFailureReasonDetailsData = action.payload;
      })
      .addCase(getFailureReasonDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      .addCase(editFailureReason.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editFailureReason.fulfilled, (state, action) => {
        state.loading = false;
        state.mainEditFailureReasonData = action.payload;
      })
      .addCase(editFailureReason.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      .addCase(deleteFailureReason.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteFailureReason.fulfilled, (state, action) => {
        state.loading = false;
        state.mainDeleteFailureReasonData = action.payload;
      })
      .addCase(deleteFailureReason.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      .addCase(getAnnouncements.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAnnouncements.fulfilled, (state, action) => {
        state.loading = false;
        state.mainAnnouncementsData = action.payload;
      })
      .addCase(getAnnouncements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      builder
      .addCase(getAnnouncementDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAnnouncementDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.mainGetAnnouncementsData = action.payload;
      })
      .addCase(getAnnouncementDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      .addCase(addAnnouncement.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addAnnouncement.fulfilled, (state, action) => {
        state.loading = false;
        state.mainAddAnnouncementData = action.payload;
      })
      .addCase(addAnnouncement.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      .addCase(editAnnouncement.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editAnnouncement.fulfilled, (state, action) => {
        state.loading = false;
        state.mainEditAnnouncementData = action.payload;
      })
      .addCase(editAnnouncement.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
    builder
      .addCase(deleteAnnouncements.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAnnouncements.fulfilled, (state, action) => {
        state.loading = false;
        state.mainDeleteAnnouncementData = action.payload;
      })
      .addCase(deleteAnnouncements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      builder
      .addCase(getCheckoutlist.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCheckoutlist.fulfilled, (state, action) => {
        state.loading = false;
        state.getCheckoutlistData = action.payload;
      })
      .addCase(getCheckoutlist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      builder
      .addCase(updateCheckOutListStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCheckOutListStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.updateCheckOutListStatusData = action.payload;
      })
      .addCase(updateCheckOutListStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      builder
      .addCase(addChecklistData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addChecklistData.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addChecklistData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      builder
      .addCase(getChecklistDataDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getChecklistDataDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.mainChecklistData = action.payload;
      })
      .addCase(getChecklistDataDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      builder
      .addCase(deleteCheckList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCheckList.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteCheckList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
    builder
      .addCase(getOutofService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOutofService.fulfilled, (state, action) => {
        state.loading = false;
        state.mainOutofServiceData = action.payload;
      })
      .addCase(getOutofService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      .addCase(addOutofService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addOutofService.fulfilled, (state, action) => {
        state.loading = false;
        state.addMainOutofServiceData = action.payload;
      })
      .addCase(addOutofService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      .addCase(getOutofServiceDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOutofServiceDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.mainOutofServiceDetailsData = action.payload;
      })
      .addCase(getOutofServiceDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      .addCase(editOutofService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editOutofService.fulfilled, (state, action) => {
        state.loading = false;
        state.mainEditOutofServiceData = action.payload;
      })
      .addCase(editOutofService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      .addCase(deleteOutofService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteOutofService.fulfilled, (state, action) => {
        state.loading = false;
        state.mainDeleteOutofServiceData = action.payload;
      })
      .addCase(deleteOutofService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      builder
      .addCase(fetchBufferRules.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBufferRules.fulfilled, (state, action) => {
        state.loading = false;
        state.bufferRulesData = action.payload;
      })
      .addCase(fetchBufferRules.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      builder
      .addCase(getRoutingConfigDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getRoutingConfigDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.getConfigData = action.payload;
      })
      .addCase(getRoutingConfigDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      builder
      .addCase(updateRoutingConfigDetails.pending, (state) => {
        state.isUpdateLoading = true;
        state.error = null;
      })
      .addCase(updateRoutingConfigDetails.fulfilled, (state, action) => {
        state.isUpdateLoading = false;
      })
      .addCase(updateRoutingConfigDetails.rejected, (state, action) => {
        state.isUpdateLoading = false;
        state.error = action.payload;
      })


      //  tsting panel
      builder
      .addCase(placeOrderApi.pending, (state) => {
        state.isplaceLoading = true;
        state.error = null;
      })
      .addCase(placeOrderApi.fulfilled, (state, action) => {
        state.isplaceLoading = false;
      })
      .addCase(placeOrderApi.rejected, (state, action) => {
        state.isplaceLoading = false;
        state.error = action.payload;
      })

      builder
      .addCase(updateOrderStatusApi.pending, (state) => {
        state.isupdateOrderStatusApioading = true;
        state.error = null;
      })
      .addCase(updateOrderStatusApi.fulfilled, (state, action) => {
        state.isupdateOrderStatusApioading = false;
      })
      .addCase(updateOrderStatusApi.rejected, (state, action) => {
        state.isupdateOrderStatusApioading = false;
        state.error = action.payload;
      })

      builder
      .addCase(updateDriverStatusApi.pending, (state) => {
        state.isupdateDriverStatusApioading = true;
        state.error = null;
      })
      .addCase(updateDriverStatusApi.fulfilled, (state, action) => {
        state.isupdateDriverStatusApioading = false;
      })
      .addCase(updateDriverStatusApi.rejected, (state, action) => {
        state.isupdateDriverStatusApioading = false;
        state.error = action.payload;
      })

      builder
      .addCase(updateDriverTasksApi.pending, (state) => {
        state.updateDriverTasksApiLoading = true;
        state.error = null;
      })
      .addCase(updateDriverTasksApi.fulfilled, (state, action) => {
        state.updateDriverTasksApiLoading = false;
      })
      .addCase(updateDriverTasksApi.rejected, (state, action) => {
        state.updateDriverTasksApiLoading = false;
        state.error = action.payload;
      })

      builder
      .addCase(fetchTerminalQuanitityApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTerminalQuanitityApi.fulfilled, (state, action) => {
        state.loading = false;
        state.fetchTerminalQuanititydata = action.payload
      })
      .addCase(fetchTerminalQuanitityApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      builder
      .addCase(getScheduleCroneApi.pending, (state) => {
        state.scheduleLoading = true;
        state.error = null;
      })
      .addCase(getScheduleCroneApi.fulfilled, (state, action) => {
        state.scheduleLoading = false;
      })
      .addCase(getScheduleCroneApi.rejected, (state, action) => {
        state.scheduleLoading = false;
        state.error = action.payload;
      })

            builder
      .addCase(getKmlData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getKmlData.fulfilled, (state, action) => {
        state.loading = false;
        state.getKmlDataCoordinate = action.payload
      })
      .addCase(getKmlData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});


export const { singleDrive } = commonDriveSlice.actions;

export default commonDriveSlice.reducer;